module.exports = "\n  <nb-layout [center]=\"layout.id === 'center-column'\">\n    <nb-layout-header fixed>\n      <app-ngx-header [position]=\"sidebar.id === 'left' ? 'normal': 'inverse'\"></app-ngx-header>\n    </nb-layout-header>\n\n    <nb-layout-column class=\"main-content\">\n      <div class=\"container\">\n          <ng-content select=\"router-outlet\"></ng-content>\n      </div>\n    </nb-layout-column>\n  </nb-layout>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/ecommerce-layout/ecommerce-layout.component.html
// module id = ./src/app/shared/ecommerce-layout/ecommerce-layout.component.html
// module chunks = main